import { authHeader } from '../_helpers';

export const cocktailService = {
  addIngredient,
  addRecipe,
  getAllIngredients,
  getAllRecipes,
  getMyRecipes,
  getIngredientById,
  getRecipeImage,
  deleteIngredient,
  deleteRecipe,
  updateCocktailCounts,
  addRemoveFavoritesCollection,
  updateFavoritesCounts
};

function getAllIngredients() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  return fetch('/api/ingredients', requestOptions).then(handleResponse);
  //return fetch('/users', requestOptions).then(handleResponse);
}

function getAllRecipes() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  return fetch('/api/recipes', requestOptions).then(handleResponse);
}

function getMyRecipes(cabinet, keyIngredients) {

  const requestOptions = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({cabinet, keyIngredients})
  }; // : ['peach_schnapps', 'vodka', 'rum']
  return fetch('/api/my_recipes', requestOptions).then(handleResponse);
}

function getIngredientById(_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch('/users/' + _id, requestOptions).then(handleResponse);
}

function getRecipeImage(_id) {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch('/api/my_recipes/' + _id, requestOptions).then(handleResponse);
}

function addIngredient(ingredient) {

  const requestOptions = {
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(ingredient)
  };

  requestOptions.method = ingredient._id ? 'PUT' : 'POST';

  return fetch('/api/ingredients' + (ingredient._id ? '/' + ingredient._id : ''), requestOptions).then(handleResponse);
}

function addRecipe(recipe) {
  const requestOptions = {
    //method: 'POST',
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(recipe)
  };

  return fetch('/api/recipes/' + recipe._id, requestOptions).then(handleResponse);
}


// prefixed function name with underscore because delete is a reserved word in javascript
function deleteIngredient(_id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch('/api/ingredients/' + _id, requestOptions).then(handleResponse);
}
function deleteRecipe(_id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };

  return fetch('/api/recipes/' + _id, requestOptions).then(handleResponse);
}

function updateCocktailCounts() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader()
  };

  return fetch('/api/ingredients/update_cocktail_ct', requestOptions).then(handleResponse);
}

function updateFavoritesCounts() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader()
  };

  return fetch('/api/recipes/update_favorites_ct', requestOptions).then(handleResponse);
}

function addRemoveFavoritesCollection(email, machine_name, add) {

  const requestOptions = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({email, machine_name, add})
  };
  return fetch('/api/favorites', requestOptions).then(handleResponse);
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return response.json();
}


// WEBPACK FOOTER //
// ./src/_services/cocktail.service.js